import { z } from 'zod';

import { duplicateNameRefinement } from '@/modules/onboarding/common/utils/duplicate-name-refinement';

export const clientSchema = (t: (key: string, options?: any) => string) =>
  z.object({
    name: z
      .string()
      .trim()
      .min(1, {
        message: t('authenticated.onboarding.clients:validation.name.required'),
      })
      .min(2, {
        message: t('authenticated.onboarding.clients:validation.name.min', {
          min: 2,
        }),
      }),
  });

export const clientsTableSchema = (t: (key: string, options?: any) => string) =>
  z.object({
    clients: z
      .array(clientSchema(t))
      .superRefine(
        duplicateNameRefinement(
          c => c.name,
          'name',
          t('authenticated.onboarding.clients:validation.name.duplicate')
        )
      ),
  });

export type ClientFormValues = z.infer<ReturnType<typeof clientSchema>>;

export type ClientsTableFormValues = z.infer<ReturnType<typeof clientsTableSchema>>;
